// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + ".modern." + {"2897":"5c58632e96164c5a8391","6400":"f34af5914e8f3e4be6c4"}[chunkId] + ".js";
};